import { FONT_SIZES, FONT_WEIGHTS, GRAY_COLORS } from '../globalTheme';

export const theme = {
	table: {
		fontFamily: 'Inter, sans-serif',
		container: {
			color: GRAY_COLORS.gray600,
			width: '100%',
			OverflowX: 'auto' as const
		},
		header: {
			backgroundColor: GRAY_COLORS.gray50,
			color: GRAY_COLORS.gray600,
			fontSize: FONT_SIZES.xs,
			fontWeight: FONT_WEIGHTS.medium,
			borderBottom: `1px solid ${GRAY_COLORS.gray200}`,
			borderTop: `1px solid ${GRAY_COLORS.gray200}`
		},
		row: {
			borderBottom: `1px solid ${GRAY_COLORS.gray200}`,
			backgroundColor: 'white'
		},
		cell: {
			padding: '12px 16px',
			color: GRAY_COLORS.gray600,
			fontSize: FONT_SIZES.md,
			fontWeight: 400
		}
	}
};

export type Theme = typeof theme;
